import { AuthenticatedService } from "../abstract/base.service";
import {
  LanguageDto,
  ActivityAreaDto,
  MetadataConfiguration
} from "@/server/app.dtos";
import {
  GetActivityAreaDtosQuery,
  GetActivityAreaMetadataGroupsConfigurationDtoQuery
} from "@/server/app.queries";
import { EditActivityAreaMetadataGroupsConfigurationCommand } from "@/server/app.commands";

export const ActivitiesAreasEndpoint = `api/activityareas`;

export class ActivitiesAreasService extends AuthenticatedService {
  GetAllByLanguage(language: LanguageDto): Promise<ActivityAreaDto[]> {
    const request = new GetActivityAreaDtosQuery();
    request.idLanguage = language.idLanguage || 1;
    return this.GetAll(request);
  }

  GetAll(request: GetActivityAreaDtosQuery): Promise<ActivityAreaDto[]> {
    return this.Get<ActivityAreaDto[]>(
      `${this.baseUrl}${ActivitiesAreasEndpoint}?${this.GetQueryStringByObject(
        request
      )}`
    );
  }

  ChangeMetadataGroups(
    command: EditActivityAreaMetadataGroupsConfigurationCommand
  ): Promise<number> {
    return this.Put<number>(
      `${this.baseUrl}${ActivitiesAreasEndpoint}/metadatagroupsconfig`,
      command
    );
  }

  GetMetadataGroupsConfiguration(
    query: GetActivityAreaMetadataGroupsConfigurationDtoQuery
  ): Promise<MetadataConfiguration> {
    return this.Get<MetadataConfiguration>(
      `${
        this.baseUrl
      }${ActivitiesAreasEndpoint}/metadatagroupsconfig?${this.GetQueryStringByObject(
        query
      )}`
    );
  }
}
